import { Flex } from 'components/base/layout-components';
import LabelsList, { TeamIconWrapper } from 'components/LabelsList';
import _ from 'lodash';
import useCustomFieldsMapper from 'common/fetchHooks/pmProvider/useCustomFieldsMapper';
import LabelListTooltipLoader from './LabelListTooltipLoader';
import MissingFiltersScopes from './MissingFiltersScope';
import { FILTER_TYPES } from 'common/constants/filters';
import { getIsEmptyFilters } from 'components/LabelsList.service';

export const TeamToolTip = ({ team, filters = {} }) => {
  const { isLoading, customFieldsById } = useCustomFieldsMapper();

  const commonFilterTypes = _.omit(filters, 'fields');
  const customFields = (filters?.fields || []).reduce((acc, field) => {
    acc[customFieldsById[field.id]] = field.value?.map(value => ({
      name: value
    }));
    return acc;
  }, {});

  const projectTeamAreas = commonFilterTypes?.project_team_areas || [];
  if (projectTeamAreas.length) {
    projectTeamAreas.forEach(item => {
      const { project, team, areas } = item;
      commonFilterTypes.project = [project];
      commonFilterTypes.team = [team];
      commonFilterTypes.areas = areas;
    });
    delete commonFilterTypes.project_team_areas;
  }

  const teamFilters = Object.entries({
    ...commonFilterTypes,
    ...customFields
  }).map(([key, value]) => ({
    key,
    label: key,
    values: value.map(({ id, name, provider_key }) => ({
      id,
      title: name || provider_key
    }))
  }));

  if (getIsEmptyFilters(filters))
    return (
      <MissingFiltersScopes filterType={FILTER_TYPES.ORGANIZATION_TEAMS} />
    );

  return (
    <Flex padding='small' direction='column'>
      <Flex>
        <TeamIconWrapper color={team?.color} />
        <b>{team?.title}</b>
        &nbsp;is composed of:
      </Flex>
      <br />
      {isLoading ? (
        <LabelListTooltipLoader />
      ) : (
        <LabelsList list={teamFilters} />
      )}
    </Flex>
  );
};
